import { render, staticRenderFns } from "./GeneralJobs.vue?vue&type=template&id=b23363a8&"
import script from "./GeneralJobs.vue?vue&type=script&lang=js&"
export * from "./GeneralJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports